// For full API documentation, including code examples, visit http://wix.to/94BuAAs

import wixWindow from 'wix-window';

$w.onReady(function () {
	//TODO: write your page related code here...

if(wixWindow.formFactor === "Desktop"){
	$w("#image30").hide();
}

$w('#gallery2').hide();
$w('#videoPlayer1').hide();
})

// Handle Showing And Hiding the Stills Gallery
export function text34_mouseIn_1(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	
	$w('#gallery2').show("fade");

}

export function gallery2_mouseIn(event){
	$w('#gallery2').show();
	

}

export function gallery2_mouseOut(event){
	$w('#gallery2').hide("fade");
	
}

export function text34_mouseOut(event) {
	$w('#gallery2').hide();
	
}

// Handle Showing and Hiding the Video Player

export function text35_mouseIn(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	$w('#videoPlayer1').show("fade");
}


export function videoPlayer1_mouseIn(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	$w('#videoPlayer1').show();
}

export function videoPlayer1_mouseOut(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	$w('#videoPlayer1').hide("fade");
}


export function text35_mouseOut(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	$w('#videoPlayer1').hide();
}

